<script setup lang="ts">
  import { breakpointsTailwind, useBreakpoints, useColorMode, useWindowSize } from '@vueuse/core'
  // import { UAParser } from 'ua-parser-js'

  const { width, height } = useWindowSize()

  const breakpoints = useBreakpoints(breakpointsTailwind)
  const activeBreakpoint = breakpoints.active()

  const colorMode = useColorMode() // Ref<'dark' | 'light'>

  const screenSize = {
    width: screen.width,
    height: screen.height,
  }

  // Just pass the complex user-agent string to `UAParser`
  const userAgent = navigator.userAgent
  // const parser = new UAParser(userAgent)

  // console.log(parser.getBrowser())
  // { name : "TikTok", version : "28.3.4", major : "28", type: undefined }

  // console.log(parser.getCPU())
  // { architecture : undefined }

  // console.log(parser.getEngine())
  // { name : "Blink", version : "110.0.5481.153" }

  // console.log(parser.getDevice())
  // { type : "mobile", vendor : "Huawei", model : "STK-LX1" }

  // console.log(parser.getOS())
  // { name : "Android", version : "10" }

  // console.log(parser.getResult())
</script>

<template>
  <main>
    <table>
      <tbody>
        <tr class="group-header">
          <td colspan="2">
            Browser
          </td>
        </tr>
        <tr>
          <td>Width x Height</td>
          <td>{{ width }} x {{ height }}  (px)</td>
        </tr>
        <tr>
          <td>Breakpoints</td>
          <td>{{ activeBreakpoint ? activeBreakpoint : 'xs' }}</td>
        </tr>
        <tr>
          <td>Color Theme</td>
          <td>{{ colorMode }}</td>
        </tr>
        <tr>
          <td colspan="2"></td>
        </tr>
        <tr class="group-header">
          <td colspan="2">
            Device
          </td>
        </tr>
        <tr>
          <td>Width x Height</td>
          <td>
            {{ screenSize.width }} x {{ screenSize.height }}
            (px)
          </td>
        </tr>
        <tr>
          <td>User Agent</td>
          <td>{{ userAgent }}</td>
        </tr>
      </tbody>
    </table>
  </main>
</template>

<style scoped>
  table {
    border-collapse: collapse;
  }
  td {
    border: 1px solid gray;
    padding: 4px 8px;
    border-collapse: collapse;
  }
  td:first-child {
    white-space: nowrap;
  }
  .group-header {
    font-weight: bold;
  }
</style>
